module.exports = __webpack_public_path__ + "static/media/imaginxp-loginbanner-3.5fe745d6.jpg";